module.exports = __webpack_public_path__ + "img/zz.4f03d421.png";